import { render, staticRenderFns } from "./security_scanner_alert.vue?vue&type=template&id=702739f0&"
import script from "./security_scanner_alert.vue?vue&type=script&lang=js&"
export * from "./security_scanner_alert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports